export function describeClientPosition(payableByClientMinorUnits, { netted }) {
    const owedByClient = payableByClientMinorUnits >= 0;
    const displayMinorUnits = owedByClient ? payableByClientMinorUnits : -payableByClientMinorUnits;
    if (netted) {
        return { label: owedByClient ? 'Net due by client' : 'Net due to client', displayMinorUnits, inCredit: !owedByClient };
    }
    return { label: owedByClient ? 'Due by client' : 'Due to client', displayMinorUnits, inCredit: !owedByClient };
}
